/**
 * Handles converting a template literal tag to string.
 */
export default class CssTemplateLiteralTag {
	/**
	 * Converts a template literal to string.
	 *
	 * @param strings Strings.
	 * @param values Expressions.
	 * @returns Result as string.
	 */
	public static templateToString(
		strings: TemplateStringsArray,
		...values: (string | number | boolean)[]
	): string {
		let result = '';
		for (let i = 0, max = strings.length; i < max; i++) {
			result += strings[i];
			if (i < max - 1 && values[i] !== null) {
				result += String(values[i]);
			}
		}
		return result;
	}
}
